import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'ra-core'
import { OpenSolarThemeType } from 'Themes'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const useStyles = makeOpenSolarStyles((theme: OpenSolarThemeType) => ({
  title: {},
}))

const ProductDetailDescription = ({ description }) => {
  const translate = useTranslate()
  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {translate('About this item')}
      </Typography>
      <div>{description}</div>
    </div>
  )
}

export default ProductDetailDescription
